export default "__VITE_ASSET__BClpLayL__"